import { render } from "./DropBox.vue?vue&type=template&id=484aae28&scoped=true"
import script from "./DropBox.vue?vue&type=script&lang=js"
export * from "./DropBox.vue?vue&type=script&lang=js"

import "./DropBox.vue?vue&type=style&index=0&id=484aae28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484aae28"]])

export default __exports__